import React from 'react'
import { useIntl } from 'react-intl'

export const LibraryLicenses: React.FC<{
  readonly licenses?: string[]
  readonly children: (props: {
    readonly label: string
    readonly value: string
  }) => React.ReactNode
}> = ({ licenses, children }) => {
  const { formatMessage } = useIntl()
  const hasLicenses = !!licenses && licenses?.length > 0
  const count = licenses?.length || 0

  return (
    <>
      {children({
        label: `${formatMessage({ id: 'plural_license' }, { count })}${
          hasLicenses && count > 1 ? ` (${count})` : ''
        }`,
        value: hasLicenses
          ? licenses.join(', ')
          : formatMessage({ id: 'title_unknown' })
      })}
    </>
  )
}
